var map = {
	"./240px-ResearchGate.png": 1277,
	"./32px-ResearchGate.png": 1268,
	"./512px-ORCID.png": 1532,
	"./Actuadores_electroquimicos.png": 2638,
	"./Bioelectronica.png": 8365,
	"./Biosensores_electroquimicos.png": 7222,
	"./Biosensores_electroquimicos_cardio.png": 4656,
	"./GoogleAca.png": 1460,
	"./Instagram.png": 5774,
	"./Logo200px.png": 2447,
	"./Membrana_de _tilacoides.png": 191,
	"./RaúlLucioPorto-CVU-2023-website.pdf": 5858,
	"./ResearchGate-icon.svg": 7450,
	"./Supercapacitor electroquimico 2.png": 1378,
	"./Supercapacitor electroquimico 3.png": 2507,
	"./Supercapacitor_electroquimcio_1.png": 8159,
	"./UANL.png": 6940,
	"./Youtube.png": 9189,
	"./colaboradores/BUAP.png": 8227,
	"./colaboradores/CICY.png": 4915,
	"./colaboradores/CNYN.jpg": 1761,
	"./colaboradores/FCQ.png": 7505,
	"./colaboradores/IPN.webp": 5760,
	"./colaboradores/UAM.png": 1964,
	"./colaboradores/nantes.png": 7570,
	"./ecology-science-dna.svg": 799,
	"./fotos/20230213_122108-min.jpg": 5467,
	"./fotos/20230213_122108.jpg": 996,
	"./fotos/20230214_122259.jpg": 2924,
	"./fotos/20231602.jpeg": 5877,
	"./fotos/Ady.jpeg": 8331,
	"./fotos/Ady.png": 3450,
	"./fotos/Carlo.jpeg": 5844,
	"./fotos/Carlo.jpg": 4923,
	"./fotos/Cristina.jpeg": 6342,
	"./fotos/Cristina.jpg": 33,
	"./fotos/Cristina.png": 5753,
	"./fotos/DSC_0592.JPG": 5316,
	"./fotos/DSC_0605.JPG": 4707,
	"./fotos/DSC_0607.JPG": 5697,
	"./fotos/DSC_0608.JPG": 4730,
	"./fotos/DSC_0610.JPG": 3737,
	"./fotos/DSC_0613.JPG": 3134,
	"./fotos/DSC_0618.JPG": 5521,
	"./fotos/DSC_0619.JPG": 6324,
	"./fotos/DSC_0619.jpeg": 6030,
	"./fotos/DSC_0620.jpeg": 2650,
	"./fotos/DSC_0620.jpg": 7477,
	"./fotos/DSC_0621.jpeg": 8545,
	"./fotos/DSC_0621.jpg": 3512,
	"./fotos/DSC_0622.jpeg": 1440,
	"./fotos/DSC_0623.jpeg": 6007,
	"./fotos/DSC_0624.jpeg": 9950,
	"./fotos/DSC_0625.jpeg": 4581,
	"./fotos/DSC_0626.JPG": 8350,
	"./fotos/DSC_0636.JPG": 7785,
	"./fotos/DSC_0638.JPG": 3359,
	"./fotos/DSC_0639.JPG": 514,
	"./fotos/DSC_0640.JPG": 6574,
	"./fotos/DSC_0645.JPG": 6903,
	"./fotos/DSC_0649.JPG": 7971,
	"./fotos/DSC_0658.JPG": 1629,
	"./fotos/DSC_0667.JPG": 3087,
	"./fotos/DSC_0671.JPG": 726,
	"./fotos/DSC_0673.JPG": 4404,
	"./fotos/DSC_0675.JPG": 4914,
	"./fotos/DSC_0680.JPG": 8906,
	"./fotos/DSC_0690.JPG": 657,
	"./fotos/DSC_0702.JPG": 277,
	"./fotos/DSC_0703.jpeg": 7150,
	"./fotos/DSC_0703.jpg": 8873,
	"./fotos/DSC_0713.JPG": 9415,
	"./fotos/DSC_0714.jpeg": 4334,
	"./fotos/DSC_0715.jpeg": 6821,
	"./fotos/DSC_0716.jpeg": 884,
	"./fotos/DSC_0716.jpg": 5755,
	"./fotos/DSC_0717.jpeg": 2043,
	"./fotos/Damian.png": 4766,
	"./fotos/Dra. Adela.png": 1670,
	"./fotos/Emilio.jpeg": 5098,
	"./fotos/Emilio.png": 1349,
	"./fotos/Eva.jpeg": 5149,
	"./fotos/Fabiola.jpeg": 6409,
	"./fotos/Fabiola.png": 1396,
	"./fotos/Fernanda.jpg": 519,
	"./fotos/Fernanda.png": 8343,
	"./fotos/Francisco Javier.png": 3979,
	"./fotos/Ingrid.jpeg": 4998,
	"./fotos/Ingrid.png": 166,
	"./fotos/Javier.jpeg": 1382,
	"./fotos/Johana.png": 6103,
	"./fotos/Jonathan.jpeg": 3256,
	"./fotos/Jonathan.png": 9151,
	"./fotos/Jorge Alexis.jpeg": 336,
	"./fotos/Jorge Alexis.png": 5879,
	"./fotos/Jose Julian.png": 3342,
	"./fotos/Juan Pablo.jpeg": 9773,
	"./fotos/Juan Pablo.png": 480,
	"./fotos/Julie.jpeg": 1974,
	"./fotos/Julie.jpg": 4625,
	"./fotos/Lorena.jpeg": 7500,
	"./fotos/Monse.jpg": 1956,
	"./fotos/Monse.png": 8992,
	"./fotos/Patricio.jpg": 1919,
	"./fotos/Patricio.png": 5967,
	"./fotos/Paula.jpeg": 1430,
	"./fotos/Roxana.JPG": 7446,
	"./fotos/Roxana.png": 4389,
	"./fotos/Selene.png": 2954,
	"./fotos/Seminario II.jpeg": 9514,
	"./fotos/Uriel.jpeg": 1288,
	"./fotos/Uriel.png": 3391,
	"./fotos/Vicente Arturo.jpeg": 4036,
	"./fotos/Vicente Arturo.png": 1651,
	"./fotos/Yuridia.png": 2535,
	"./fotos/ana.jpg": 5856,
	"./fotos/ana.png": 5012,
	"./fotos/braddaichi.jpg": 5075,
	"./fotos/cesaralan.jpg": 7022,
	"./fotos/d3e7c18e-444c-48cc-8fa3-9600e1f039ee.jpeg": 1581,
	"./fotos/eventos/CIIDIT.jpg": 8790,
	"./fotos/eventos/Electromobility.webp": 6918,
	"./fotos/eventos/Energy.png": 1981,
	"./fotos/eventos/Incubadora.jpg": 3695,
	"./fotos/eventos/LTH.jpg": 4249,
	"./fotos/eventos/nanotec.png": 8623,
	"./fotos/eventos/nanotecnologia.jpg": 256,
	"./fotos/eventos/python.jpg": 5239,
	"./fotos/eventos/seminario.gif": 6863,
	"./fotos/jessica.jpg": 916,
	"./fotos/jessica.png": 7952,
	"./fotos/joshua.jpg": 6878,
	"./fotos/rafa.jpg": 304,
	"./fotos/rafa.png": 1108,
	"./fotos/raphael.jpg": 9489,
	"./fotos/sergio.jpg": 3185,
	"./fotos/sergio.png": 7433,
	"./fotos/unknown.png": 3920,
	"./gnano.png": 7471,
	"./googleAcademico.png": 4577,
	"./iconos/3.png": 7859,
	"./icons-lineas/3.png": 3283,
	"./icons-lineas/AlmacenamientoEnergia.svg": 1893,
	"./icons-lineas/AlmacenamientoEnergiaW.png": 8112,
	"./icons-lineas/BioElectronica.png": 771,
	"./icons-lineas/BioElectronica.svg": 7447,
	"./icons-lineas/BioElectrónica.png": 1359,
	"./icons-lineas/BioElectrónica.svg": 9331,
	"./icons-lineas/BiosensoresElectro.svg": 354,
	"./icons-lineas/BiosensoresElectro2.svg": 7983,
	"./icons-lineas/BiosensoresElectro2W.png": 6487,
	"./icons-lineas/ConversionEnergia.svg": 1723,
	"./icons-lineas/ConversionEnergiaW.png": 2174,
	"./icons-lineas/MusculosArtificiales.svg": 6603,
	"./icons-lineas/MusculosArtificialesW.png": 6744,
	"./icons-lineas/Nanomateriales.svg": 3627,
	"./icons-lineas/NanomaterialesW.png": 3476,
	"./icons-lineas/logotejidosR.svg": 3613,
	"./icons-lineas/logotejidosR1.png": 3952,
	"./icons-lineas/mecatronicaR.png": 6100,
	"./icons-lineas/mecatronicaR.svg": 8560,
	"./icons-lineas/path11826.png": 6217,
	"./icons-lineas/path5019.png": 2210,
	"./icons-lineas/software.png": 5925,
	"./icons-lineas/software.svg": 1273,
	"./infografias/Almacenamiento de energía.png": 8798,
	"./infografias/Bioelectronica.png": 2019,
	"./infografias/BiosensoresElectroquimicos.png": 8708,
	"./infografias/Conversión de energía.png": 8360,
	"./infografias/MicroBiosupercapacitores.png": 871,
	"./infografias/NanocapsulasFarmacos.png": 4410,
	"./infografias/Software.png": 8165,
	"./infografias/Tejidos.png": 1860,
	"./interface-arrows-button-right-duoble.svg": 8144,
	"./interface-content-book-2.svg": 1646,
	"./interface-edit-view.svg": 1062,
	"./interface-file-bookmark.svg": 4419,
	"./interface-help-customer-support-2.svg": 7217,
	"./interface-home-3.svg": 1361,
	"./interface-user-circle.svg": 3994,
	"./logo4-1.png": 8571,
	"./logo4-4.png": 294,
	"./logoB1.png": 9054,
	"./not_found.jpg": 6216,
	"./particlesjs-config": 440,
	"./particlesjs-config.json": 440,
	"./stacked-peaks-haikei.svg": 9308,
	"./stacked-peaks-haikei2.svg": 3158,
	"./travel-airport-passport.svg": 2915,
	"./travel-map.svg": 7191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;